import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(24);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const ListAddItem = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <path d="M0.19101 0H13.691V4H0.19101V0Z" />
      <path d="M0.19101 6.5H13.691V9.75H24.191V10.5H0.19101V6.5Z" />
      <path d="M0.19101 13.5H24.191V17.5H0.19101V13.5Z" />
      <path d="M0.19101 20H24.191V24H0.19101V20Z" />
      <path d="M24.1718 3.04445H21.1273V0H18.4605V3.04445H15.416V5.71132H18.4605V8.75604H21.1273V5.71132H24.1718V3.04445Z" />
    </SvgIcon>
  );
};

export default memo(ListAddItem);
